<app-mens-intimate-wash
  htmlTitle="<strong>Important: Protect</strong> Your Skin Barrier"
  question="We strongly recommend including Men's Intimate Wash with your prescription. Would you like to add it to your order?"
>
  <p class="mb-4">
    Many men don’t realize that everyday soaps can <strong>dry out intimate skin and reduce sensitivity</strong>,
    leading to irritation and discomfort over time.
  </p>
  <p class="mb-4">
    For men using ED medication,
    <strong>maintaining skin comfort and sensitivity helps you get the most out of your treatment</strong>, especially
    with regular use.
  </p>
  <p class="mb-4">
    A <strong>pH-balanced men’s intimate wash</strong> helps protect sensitive skin, reduce irritation, and maintain
    comfort—supporting better sensation and a smoother overall experience.
  </p>
</app-mens-intimate-wash>
